import request from '@/utils/request'

// 获取角色列表
export function getRoleList(data) {
  return request({
    url: '/account-bi/role/getList',
    method: 'post',
    data: data
  })
}

// 新增或编辑角色
export function addEditRole(data) {
  return request({
    url: '/account-bi/role/addEdit',
    method: 'post',
    data: data
  })
}

// 删除角色
export function deleteRole(params) {
  return request({
    url: '/account-bi/role/delete',
    method: 'get',
    params: params
  })
}

// 编辑角色权限
export function editRolePermission(data) {
  return request({
    url: '/account-bi/role/editPermission',
    method: 'post',
    data: data
  })
}

// 获取角色下拉框
export function getRoleSelect(params) {
  return request({
    url: '/account-bi/role/getSelect',
    method: 'get',
    params: params
  })
}

// 获取用户下拉框
export function getUserSelect(params) {
  return request({
    url: '/account-bi/user/getSelect',
    method: 'get',
    params: params
  })
}






